import { DateOptions } from "../../charts/models/date";


export const formatDate = (date: Date, format: DateOptions) => {
    const options: Intl.DateTimeFormatOptions = {
        weekday: format.weekday,
        day: format.day,
        month: format.month,
        year: format.year
    };
    return new Intl.DateTimeFormat(format.language, options).format(date).toUpperCase().replace(/,/g, '')
}
